import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const getProjectTimeline = (projectId) => Axios.get(`/projects/timeline/${projectId}`);

const useProjectTimeline = (projectId) => {
    return useQuery({
        queryKey: ['projectTimeline', projectId],
        queryFn: () => getProjectTimeline(projectId),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
    });
};

const forceReloadProjectTimeline = (ID) => {
    return queryClient.invalidateQueries({ queryKey: ['projectTimeline', ID] });
};

export { useProjectTimeline, forceReloadProjectTimeline };
